export default {
	styleOverrides: {
		root: {
			height: '19px',
			borderRadius: '4px',
		},
		label: {
			padding: '0 8px',
			fontSize: '12px',
			fontWeight: 600,
		},
	},
};
